<template>
  <div class="wrapper__content-sale-document col-container">
    <div class="col-header">
      <div class="col-header-left">
        <ButtonCirclePlusComponent
          v-if="$canOpen('sales.remissions.add')"
          @onClick="$router.push({ name: 'sales.remissions.add' })"
        />
        <span class="col-title">Guías de Remisión</span>
      </div>
      <div class="col-actions">
        <ButtonFilterComponent
          @onChangeFilters="onChangeFilters"
          @onApplyFilters="onApplyFilters"
          :setFilters="searchFilters"
          :loading="loading"
          :setStatus="filterStatus"
          placeholder="Buscar por número"
          isStatus
          isSearch
          isOrderBy
          isDates
          class="mx-2"
        />
      </div>
    </div>
    <template>
      <WrapperScrollbarComponent @scrollingEnd="infiniteHandler">
        <RemissionCardComponent
          v-for="(remission, index) in sortedRemissions"
          :key="remission.id || index"
          :remission="remission"
          @onDocUpdate="onDocUpdate"
          @onDocDeleted="onDocDeleted"
        />
        <infinite-loading
          @distance="90"
          @infinite="infiniteHandler"
          ref="infiniteLoading"
        >
          <div slot="spinner">
            <SkeletonOneCardComponent />
          </div>
          <div slot="no-more"></div>
          <div slot="no-results">
            <RemissionEmptyComponent v-if="!remissions.length" />
          </div>
        </infinite-loading>
      </WrapperScrollbarComponent>
    </template>
  </div>
</template>

<script>
import ButtonCirclePlusComponent from "../../../components/ButtonCirclePlus";
import ButtonFilterComponent from "../../../components/DrawerFilter";
import RemissionCardComponent from "./RemissionCard";
import SkeletonOneCardComponent from "@/components/Animations/Loading/SkeletonOneCard";
import WrapperScrollbarComponent from "../../../../components/WrapperScrollbar";
import RemissionEmptyComponent from "./Empty";
import remissionService from "../services/remissionService";

export default {
  name: "RemissionColumnsComponent",
  data() {
    return {
      loading: true,
      searchFilters: {},
      filterStatus: [
        { label: "Borrador", key: "draft" },
        { label: "Aprobada", key: "success" },
        { label: "Anulada", key: "nuled" },
        { label: "Fallida", key: "failed" }
      ],
      page: 1,
      remissions: [],
      breakScroll: false
    };
  },
  computed: {
    filterOrderBy() {
      const { orderBy } = this.searchFilters;
      return orderBy;
    },
    requestFilters() {
      const { search, from, to, status } = this.searchFilters;
      // Only include defined/non-null values to prevent API confusion
      const filters = {};
      if (search) filters.search = search;
      if (from) filters.from = from;
      if (to) filters.to = to;
      if (status) filters.status = status;
      return filters;
    },
    sortedRemissions() {
      return this.remissions.concat().sort((a, b) => {
        if (this.filterOrderBy && this.filterOrderBy === "desc") {
          return a.total > b.total ? -1 : 1;
        } else if (this.filterOrderBy && this.filterOrderBy === "asc") {
          return a.total < b.total ? -1 : 1;
        }
        // Default: sort by date descending (most recent first)
        const dateA = a.created_at ? new Date(a.created_at) : new Date(0);
        const dateB = b.created_at ? new Date(b.created_at) : new Date(0);
        return dateB - dateA;
      });
    },
    getRemissionsFilters() {
      const { documents } = this.$store.getters.getModule("sales");
      return documents.remissions.filters.get;
    }
  },
  methods: {
    updatedSearchFilters(filters) {
      this.searchFilters = { ...this.searchFilters, ...filters };
      this.$store.dispatch("salesDocumentsFiltersGet", {
        documentKey: "remissions",
        filters: this.searchFilters
      });
    },
    onChangeFilters(filters) {
      this.updatedSearchFilters(filters);
    },
    onApplyFilters() {
      this.onAsyncDataForDates();
    },
    onDocUpdate({ id, data }) {
      const idx = this.remissions.findIndex(d => d.id === id);
      if (idx !== -1) this.$set(this.remissions, idx, data);
    },
    onDocDeleted(id) {
      this.remissions = this.remissions.filter(d => d.id !== id);
    },
    async getRemissions($state) {
      try {
        const response = await remissionService
          .getRemissions({
            params: { page: this.page, ...this.requestFilters }
          })
          .finally(() => {
            this.breakScroll = false;
            this.loading = false;
          });
        const { data } = response.data || {};
        // El interceptor de Api.js "silencia" los GET cancelados por deduplicación
        // devolviendo { data: {} }. Sin este guard, data.length revienta, el catch
        // se lo traga y $state nunca se resuelve: el infinite-loading queda colgado
        // y la columna solo vuelve a cargar recargando la página entera.
        if (!Array.isArray(data)) {
          $state.loaded();
          return;
        }

        if (data && data.length) {
          if (this.page === 1) {
            this.remissions = data;
          } else {
            // Deduplicate: only push items not already in the list
            const existingIds = new Set(this.remissions.map(r => r.id));
            const newItems = data.filter(item => !existingIds.has(item.id));
            if (newItems.length === 0) {
              // All returned items are already shown — no more unique data
              $state.complete();
              return;
            }
            newItems.forEach(item => this.remissions.push(item));
          }
          this.page++;
          $state.loaded();
        } else {
          $state.complete();
        }
      } catch (e) {
        return false;
      }
    },
    infiniteHandler($state) {
      if (!$state || typeof $state.complete !== "function") return;
      if (this.breakScroll) return false;
      this.breakScroll = true;
      this.getRemissions($state);
    }
  },
  components: {
    ButtonCirclePlusComponent,
    ButtonFilterComponent,
    RemissionCardComponent,
    SkeletonOneCardComponent,
    WrapperScrollbarComponent,
    RemissionEmptyComponent
  },
  mounted() {
    this.searchFilters = this.getRemissionsFilters;
  }
};
</script>

<style lang="scss" scoped></style>
